/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
import React, { useContext, useState, useEffect, useMemo } from 'react';
import _ from 'underscore';
import lodash from 'lodash';
import { Button, ButtonGroup } from 'react-bootstrap';
import Badge from 'components/v2/Badge';
import Container from 'components/v2/container';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { getCarriersByMarket, getCarriersWithOffer, getCommitmentDispatched, } from 'utils/OfferPlannerAPIUtils';
import MarketsAPIUtils from 'utils/MarketsAPIUtils';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import LoadingCircle from 'components/ui/LoadingCircle';
import Multiselect from 'components/v2/multi-select';
import Select from 'components/v2/select';
import TextField from 'components/v2/forms/TextField';
import Pagination from 'components/v2/Pagination';
import SessionStore from 'stores/SessionStore';
import CustomerSearch from 'components/site/customer-search';
import { fetchOfferPlannerData, mapOfferPlannerData, findCommitmentDispatched, findCarriersWithNoRates, filterOfferPlannerList, findCarriersWithOffer, } from './helpers.js';
import OfferPlannerModal from './OfferPlannerModalTemplate';
import OfferPlannersList from './OfferPlannersList';
import COLUMNS from './columns';
import { carrierOfferModal, totalCommitmentModal, commitmentDispatchedModal, containersDispatchedModal, containersNotAvailableModal, LastFreeDayModal, carriersWithRateModal, carriersWithNoRateModal, containersAvailableModal, } from './OfferPlannerModalContainer';
import ActiveFilters from './ActiveFilters';
const THREE_PLUS_DAYS = moment().add(2, 'days').startOf('day').toISOString();
const TWO_PLUS_DAYS = moment().add(2, 'days').startOf('day').toISOString();
const TOMORROW = moment().add(1, 'days').startOf('day').toISOString();
const TODAY = moment().startOf('day').toISOString();
const PAST_DAYS = moment().subtract(60, 'days').startOf('day').toISOString();
const SERVICE_TYPES = [
    { name: 'Drop & Hook', slug: 'drive_hook' },
    { name: 'Live Load/Unload', slug: 'liveLoad_unLoad' },
];
const LFD_TYPES = [
    { name: 'Past LFD', slug: 'past_lfd' },
    { name: 'LFD Today', slug: 'lfd_today' },
    { name: 'LFD Tomorrow', slug: 'lfd_tomorrow' },
    { name: 'LFD 2+ Days', slug: 'lfd_2days' },
    { name: 'LFD Unknown', slug: 'lfd_unknown' },
];
const TOTAL_COMMITMENT = 'totalCommitment';
const COMMITMENT_DISPATCHED = 'commitmentDispatched';
const CONTAINERS_DISPATCHED = 'containersDispatched';
const CONTAINERS_NOT_AVAILABLE = 'containersNotAvailable';
const CONTAINERS_AVAILABLE = 'containersAvailable';
const LFD_MODAL_TYPES = [
    'pastLfd',
    'todayLfd',
    'tomorrowLfd',
    'twoDayLfd',
    'unknownLfd',
];
const CARRIER_WITH_OFFER = 'carrierWithOffer';
const CARRIER_WITH_RATES = 'carrierWithRates';
const CARRIER_WITH_NO_RATES = 'carrierWithNoRates';
const ORIGIN = 'Origin';
const DESTINATION = 'Destination';
const PER_PAGE = 50; // shipments pulled per page, not lanes shown
const DEFAULT_SORT_COLUMN = 'origin';
const DEFAULT_SORT_BY = 'origin.0.zipcode';
const ASCENDING = 'asc';
const DESCENDING = 'desc';
const FILTERS = {
    _ID: '_id',
    YARD: 'yard',
    STATUS: 'status',
    CONSIGNEE: 'consignee',
    SHIPPER: 'shipper',
    CARRIER: 'carrier',
    CONTAINER_NUMBER: 'container_number',
    MASTER_BILL: 'master_bill_number',
    PAGINATION: 'pagination',
    DATE_RANGE: 'daterange',
    WINDOW_START: 'window_start',
    WINDOW_END: 'window_end',
    CALENDAR: 'calendar',
    SHIPPER_REMOVE: 'shipper_remove',
    CARRIER_REMOVE: 'carrier_remove',
    CONSIGNEE_REMOVE: 'consignee_remove',
    SORT_BY_REMOVE: 'sort_by_remove',
    STATUS_REMOVE: 'status_remove',
    YARD_REMOVE: 'yard_remove',
    CONTAINER_REMOVE: 'container_remove',
    MASTER_BILL_REMOVE: 'master_bill_remove',
};
export default function OfferPlanner(props) {
    function handleSessionChange() {
        const updatedUserType = SessionStore.getUserType();
        setUserType(updatedUserType);
        const mappedColumns = COLUMNS.filter((c) => {
            return c.show && c.users.includes(updatedUserType);
        });
        setColumns(mappedColumns);
    }
    const defaultQueryParams = {
        skip: 0,
        limit: PER_PAGE,
        sortColumn: DEFAULT_SORT_COLUMN,
        sortBy: DEFAULT_SORT_BY,
        sortOrder: DESCENDING,
    };
    const [originZoneInput, setOriginZoneInput] = useState('');
    const [destinationZoneInput, setDestinationZoneInput] = useState('');
    const [originZone, setOriginZone] = useState('');
    const [destinationZone, setDestinationZone] = useState('');
    const [marketMulti, setMarketMulti] = useState([]);
    const [marketsList, setMarketsList] = useState([]);
    const [serviceType, setServiceTypeMulti] = useState([]);
    const [lfdValue, setLfdValue] = useState([]);
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [clearSelectedCustomer, setClearSelectedCustomer] = useState(false);
    const [selectedOpsManagers, setSelectedOpsManagers] = useState([]);
    const [clearSelectedOpsManager, setClearSelectedOpsManager] = useState(false);
    const [showOfferPlannerModal, setShowOfferPlannerModal] = useState(false);
    const [offerPlannerModalBody, setOfferPlannerModalBody] = useState({});
    const [offerPlanners, setOfferPlanners] = useState([]);
    const [rawList, setRawList] = useState([]);
    const [query, setQuery] = useState(defaultQueryParams);
    const [paginationCount, setPaginationCount] = useState(0);
    const [paginationPages, setPaginationPages] = useState(0);
    const [userType, setUserType] = useState(SessionStore.getUserType());
    const [columns, setColumns] = useState([]);
    const [clearMarket, setClearMarket] = useState(false);
    const [clearServiceType, setClearServiceType] = useState(false);
    const [clearLfd, setClearLfd] = useState(false);
    const [modalItems, setModalItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [marketLoading, setMarketLoading] = useState(true);
    const [laneQuery, setLaneQuery] = useState(true);
    const [modalIndex, setModalIndex] = useState();
    const [modalType, setModalType] = useState([]);
    const [confirmationModal, setConfirmationModal] = useState({});
    const [cachedOffers, setCachedOffers] = useState([]);
    const [page, setPage] = useState(1);
    const getOfferPlannerData = async (query) => {
        const offerPlannerList = await fetchOfferPlannerData(query, setPaginationPages, setPaginationCount); // Gets lanes, lane rates, and shipments
        const formattedData = mapOfferPlannerData(offerPlannerList); // Data formatted for table
        return { offerPlannersList: formattedData, rawList: offerPlannerList };
    };
    function onFilterChanged(type, value, toRemove) {
        setQuery(Object.assign(Object.assign({}, query), value));
    }
    const commitmentDispatched = async (offers) => {
        try {
            const offerPlannersList = await findCommitmentDispatched(offers);
            return offerPlannersList;
        }
        catch (e) {
            console.error('failed to fetch offer planner list: ', e);
        }
    };
    const carriersWithNoRates = async (offers) => {
        try {
            const offerPlannersList = await findCarriersWithNoRates(offers);
            return offerPlannersList;
        }
        catch (e) {
            console.error('failed to fetch offer planner list: ', e);
        }
    };
    const getCarriersWithOffer = async (offers) => {
        try {
            const offerPlannersList = await findCarriersWithOffer(offers);
            return offerPlannersList;
        }
        catch (e) {
            console.error('failed to fetch offer planner list: ', e);
        }
    };
    const getOfferPlannerList = async (search) => {
        setLoading(true);
        try {
            let { offerPlannersList, rawList } = await getOfferPlannerData(search);
            if (rawList) {
                setRawList(rawList);
            }
            if (offerPlannersList) {
                setOfferPlanners(offerPlannersList);
                setCachedOffers(offerPlannersList);
            }
            setLoading(false);
            await processList(offerPlannersList);
        }
        catch (e) {
            console.error('failed to fetch offer planner list: ', e);
        }
    };
    const filterList = async () => {
        if (rawList) {
            const formattedData = filterOfferPlannerList(rawList, originZone, destinationZone, serviceType, marketMulti, lfdValue, selectedCustomers, selectedOpsManagers);
            if (formattedData) {
                setOfferPlanners(formattedData);
                setLoading(false);
            }
            await processList(formattedData);
        }
    };
    const processList = async (offerPlannersList) => {
        setLoading(false);
        if (offerPlannersList && !offerPlannersList.length) {
            setLoading(false);
            setOfferPlanners([]);
            return;
        }
        // Get carrier commitment for the lane
        const start = new Date();
        // Get carrier in lane's market who are not rated
        const carriersWithNoCommitment = await carriersWithNoRates(offerPlannersList);
        if (carriersWithNoCommitment) {
            setOfferPlanners(carriersWithNoCommitment);
            setCachedOffers(carriersWithNoCommitment);
        }
        const end = new Date();
        console.log('Carrier with no rates took ', end - start);
        const start2 = new Date();
        // Get carrier with offers created for lane's shipments
        const carriersWithOffer = await getCarriersWithOffer(offerPlannersList);
        if (carriersWithOffer) {
            setOfferPlanners(carriersWithOffer);
            setCachedOffers(carriersWithOffer);
        }
        const end2 = new Date();
        console.log('Carriers with offer took ', end2 - start2);
        const start0 = new Date();
        const offersWithCommitment = await commitmentDispatched(offerPlannersList);
        if (offersWithCommitment) {
            setOfferPlanners(offersWithCommitment);
            setCachedOffers(offersWithCommitment);
        }
        const end0 = new Date();
        console.log('Carriers with commitment offer took ', end0 - start0);
        setLoading(false);
        setMarketLoading(false);
    };
    // Front End Filters (Updates Lanes currently displayed)
    useEffect(() => {
        let newOffers = cachedOffers;
        if (lfdValue && lfdValue.length) {
            newOffers = newOffers.filter((lane) => {
                console.log('Lane', lane);
                if (lfdValue.includes('LFD Today') && lane.lfd_today.length > 0) {
                    return lane;
                }
                if (lfdValue.includes('LFD Tomorrow') && lane.lfd_tomorrow.length > 0) {
                    return lane;
                }
                if (lfdValue.includes('Past LFD') && lane.past_lfd.length > 0) {
                    return lane;
                }
                if (lfdValue.includes('LFD 2+ Days') && lane.lfd_2days.length > 0) {
                    return lane;
                }
                if (lfdValue.includes('LFD Unknown') && lane.lfd_unknown.length > 0) {
                    return lane;
                }
                return false;
            });
        }
        if (serviceType && serviceType.length) {
            newOffers = newOffers.filter((lane) => {
                console.log('Lane', lane);
                if (serviceType.includes('Drop & Hook') &&
                    lane.type === 'Drop & Hook') {
                    return lane;
                }
                if (serviceType.includes('Live Load/Unload') &&
                    lane.type === 'Live Load/Unload') {
                    return lane;
                }
                return false;
            });
        }
        if (selectedOpsManagers && selectedOpsManagers.length) {
            newOffers = newOffers.filter((lane) => {
                if (selectedOpsManagers
                    .map((o) => o.email)
                    .includes(lane.operations_manager)) {
                    return lane;
                }
                return false;
            });
        }
        if (selectedCustomers && selectedCustomers.length) {
            newOffers = newOffers.filter((lane) => {
                if (selectedCustomers.map((c) => c._id).includes(lane.customerId)) {
                    return lane;
                }
                return false;
            });
        }
        if (marketMulti && marketMulti.length) {
            newOffers = newOffers.filter((lane) => {
                return marketMulti.includes(lane.marketCode);
            });
        }
        if (originZone) {
            newOffers = newOffers.filter((lane) => {
                return lane.origin === originZone;
            });
        }
        if (destinationZone) {
            newOffers = newOffers.filter((lane) => {
                return lane.destination === destinationZone;
            });
        }
        setOfferPlanners(newOffers);
    }, [
        serviceType,
        lfdValue,
        selectedCustomers,
        marketMulti,
        originZone,
        destinationZone,
    ]);
    useEffect(() => {
        async function getData() {
            const results = await getOfferPlannerList(Object.assign(Object.assign(Object.assign({}, defaultQueryParams), { page: page }), query));
        }
        getData();
    }, [query]);
    useEffect(() => {
        const getMarketsList = async () => {
            try {
                const marketsList = await MarketsAPIUtils.getMarkets();
                if (marketsList.entity.markets) {
                    const marketNames = _.map(marketsList.entity.markets, (market) => {
                        return {
                            _id: market.id,
                            name: market.name,
                            slug: market.code,
                        };
                    });
                    setMarketsList(marketNames);
                }
            }
            catch (e) {
                console.error('failed to fetch market values: ', e);
            }
        };
        getMarketsList();
        handleSessionChange();
        SessionStore.addChangeListener(handleSessionChange);
        return () => {
            SessionStore.removeChangeListener(handleSessionChange);
        };
    }, []);
    const hasOfferPlanners = offerPlanners && offerPlanners.length > 0;
    const renderOfferPlannerHeader = () => {
        return (React.createElement("div", { className: "flex" },
            React.createElement("h3", { className: "my-0 mb-4 w-full" }, "Offers Planner")));
    };
    const clearFilter = (type, setter, inputSetter) => {
        setPage(1);
        if (inputSetter) {
            setter('');
            inputSetter('');
        }
        else {
            setter([]);
        }
        const newQuery = Object.assign({}, query);
        delete newQuery[type];
        setQuery(newQuery);
    };
    function renderBadgeList(list) {
        return list.map((l, index) => {
            let name = index === list.length - 1 ? l : `${l},`;
            return React.createElement("span", { className: "ml-2" }, name);
        });
    }
    const renderActiveFilters = () => {
        return (React.createElement("div", { className: "flex mb-4" },
            React.createElement("span", { className: "mr-4 text-bold" }, originZone ||
                destinationZone ||
                marketMulti.length ||
                serviceType.length ||
                lfdValue.length
                ? `Active Filters:  `
                : `Active Filters: None`),
            originZone ? (React.createElement(Badge, { color: "blue", className: "mr-1", withRemove: true, onRemove: () => clearFilter('originZone', setOriginZone, setOriginZoneInput) },
                "Origin: ",
                originZone)) : null,
            destinationZone ? (React.createElement(Badge, { color: "blue", className: "mr-1", withRemove: true, onRemove: () => clearFilter('destinationZone', setDestinationZone, setDestinationZoneInput) },
                "Destination: ",
                destinationZone)) : null,
            marketMulti && marketMulti.length ? (React.createElement(Badge, { color: "blue", className: "mr-1", withRemove: true, onRemove: () => clearFilter('marketCode', setMarketMulti) },
                "Markets: ",
                renderBadgeList(marketMulti))) : null,
            serviceType && serviceType.length ? (React.createElement(Badge, { color: "blue", className: "mr-1", withRemove: true, onRemove: () => clearFilter('serviceType', setServiceTypeMulti) },
                "Type: ",
                renderBadgeList(serviceType))) : null,
            lfdValue.length > 0 && (React.createElement(Badge, { color: "blue", className: "mr-1", withRemove: true, onRemove: () => clearFilter('lastFreeDate', setLfdValue) },
                "LFD: ",
                renderBadgeList([lfdValue]))),
            (selectedCustomers === null || selectedCustomers === void 0 ? void 0 : selectedCustomers.length) > 0 && (React.createElement(Badge, { color: "blue", className: "mr-1", withRemove: true, onRemove: () => clearFilter('shipper', setSelectedCustomers) },
                "Customer: ",
                renderBadgeList(selectedCustomers.map((c) => c.name)))),
            (selectedOpsManagers === null || selectedOpsManagers === void 0 ? void 0 : selectedOpsManagers.length) > 0 && (React.createElement(Badge, { color: "blue", className: "mr-1", withRemove: true, onRemove: () => clearFilter('shipper', setSelectedOpsManagers) },
                "OpsManager:",
                ' ',
                renderBadgeList(selectedOpsManagers.map((o) => o.name))))));
    };
    const getHandleValueChange = (type) => {
        return (value) => {
            if (type === ORIGIN) {
                setOriginZoneInput(value);
            }
            else {
                setDestinationZoneInput(value);
            }
        };
    };
    function handleLocationChange(type, zip) {
        let key;
        if (type === ORIGIN) {
            setOriginZone(zip);
            key = 'originZip';
        }
        else {
            setDestinationZone(zip);
            key = 'destinationZip';
        }
        const newQuery = Object.assign(Object.assign({}, query), { [key]: zip });
        setPage(1);
        setQuery(newQuery);
    }
    function onHeaderClick(column) {
        if (column.sort) {
            let newSortOrder = query.sortOrder;
            let sortBy;
            if (column.attribute === 'customer') {
                sortBy = 'shipper_name';
            }
            else if (column.attribute === 'origin') {
                sortBy = 'origin.0.zipcode'; // should we unwind the origin/destination in the aggregation instead of referencing it with an index?
            }
            else if (column.attribute === 'destination') {
                sortBy = 'destination.0.zipcode';
            }
            else if (column.attribute === 'type') {
                sortBy = 'service_type';
            }
            else {
                return;
            }
            if (query.sortBy === sortBy) {
                newSortOrder = query.sortOrder === ASCENDING ? DESCENDING : ASCENDING;
            }
            else {
                newSortOrder = ASCENDING;
            }
            setQuery(Object.assign(Object.assign({}, query), { sortColumn: column.attribute, // doesn't actually affect backend sort
                sortBy, sortOrder: newSortOrder }));
        }
    }
    const renderZoneField = (type) => {
        return (React.createElement("div", { className: "flex flex-row" },
            React.createElement("div", null,
                React.createElement(TextField, { type: "text", disabled: loading, value: type === ORIGIN ? originZoneInput : destinationZoneInput, placeholder: type === ORIGIN ? 'Origin' : 'Destination', onChange: getHandleValueChange(type) })),
            React.createElement("div", { className: "actions" },
                React.createElement("button", { className: "button button-hollow-green ml-2", type: "button", disabled: loading, onClick: () => {
                        if (type === ORIGIN) {
                            handleLocationChange(type, originZoneInput);
                        }
                        else {
                            handleLocationChange(type, destinationZoneInput);
                        }
                    } }, "Add"))));
    };
    const handleSelectMarketMulti = (value) => {
        let selectedValue = value.map((val) => {
            return val.name;
        });
        setMarketMulti(selectedValue);
        const newQuery = Object.assign(Object.assign({}, query), { marketCode: value.map((v) => v.slug) });
        setPage(1);
        setQuery(newQuery);
    };
    const renderFilterbyMarketMulti = () => {
        return (React.createElement("div", { className: "mb-4" },
            React.createElement(Multiselect, { label: "Market", items: marketsList, disabled: marketLoading, selectedItems: marketMulti, onSelect: handleSelectMarketMulti, clear: clearMarket })));
    };
    const handleSelectServiceTypeMulti = (value) => {
        let selectedValue = value.map((val) => {
            return val.name;
        });
        setServiceTypeMulti(selectedValue);
        const newQuery = Object.assign(Object.assign({}, query), { serviceType: value.map((v) => {
                return v.slug === 'drive_hook' ? 'drop' : 'live';
            }) });
        setPage(1);
        setQuery(newQuery);
    };
    const renderServiceTypesMulti = () => {
        return (React.createElement("div", { className: "mb-4" },
            React.createElement(Multiselect, { label: "Type", items: SERVICE_TYPES, disabled: loading, onSelect: handleSelectServiceTypeMulti, clear: clearServiceType })));
    };
    const handleSelectLfd = (value) => {
        setLfdValue(value);
        let lfdQuery;
        if (value === 'Past LFD') {
            lfdQuery = [PAST_DAYS, TODAY];
        }
        else if (value === 'LFD Today') {
            lfdQuery = [TODAY, TOMORROW];
        }
        else if (value === 'LFD Tomorrow') {
            lfdQuery = [TOMORROW, TWO_PLUS_DAYS];
        }
        else if (value === 'LFD 2+ Days') {
            lfdQuery = [TWO_PLUS_DAYS, null];
        }
        else if (value === 'LFD Unknown') {
            lfdQuery = [null, null];
        }
        const newQuery = Object.assign(Object.assign({}, query), { lastFreeDate: lfdQuery });
        setPage(1);
        setQuery(newQuery);
    };
    const renderFilterbyLfd = () => {
        return (React.createElement("div", { className: "mb-4" },
            React.createElement(Select, { showCaption: true, hideLabel: true, caption: "LFD", selected: lfdValue, items: LFD_TYPES.map((l) => l.name), onSelect: handleSelectLfd })));
    };
    const renderShippers = () => {
        return (React.createElement(CustomerSearch, { type: "shippers", placeholder: "Customer", className: "form-control", onSelect: handleShipperSelection }));
    };
    const renderAdmins = () => {
        return (React.createElement(CustomerSearch, { type: "admins", placeholder: "Ops Manager", className: "form-control", onSelect: handleOpsManagerSelection }));
    };
    const handleShipperSelection = (item, value) => {
        if (selectedCustomers.map((c) => c._id).includes(value._id)) {
            console.log(`Cannot add customer ${item}: It is already present in the active filters`);
            return;
        }
        let shippers;
        setSelectedCustomers((current) => {
            shippers = [...current, { name: item, _id: value._id }];
            return shippers;
        });
        const newQuery = Object.assign(Object.assign({}, query), { shipper: shippers.map((s) => s._id) });
        setPage(1);
        setQuery(newQuery);
    };
    const handleOpsManagerSelection = async (item, value) => {
        const { email, name } = value;
        const query = {
            operations_manager: email,
        };
        if (selectedOpsManagers.map((o) => o.email).includes(email)) {
            console.log(`Cannot add Ops Manager ${item}: It is already present in the active filters`);
            return;
        }
        const newShippers = await UserWebAPIUtils.getManagedCustomers(query);
        let shippers;
        setSelectedOpsManagers((current) => {
            const opsManagers = [...current, { name, email, shippers: newShippers }];
            shippers = opsManagers.reduce((acc, cur) => {
                return acc.concat(cur.shippers);
            }, []);
            shippers = _.uniq(shippers);
            return opsManagers;
        });
        const newQuery = {
            shipper: shippers.map((s) => s._id),
        };
        if (!newShippers || !newShippers.length) {
            setOfferPlanners([]);
            console.log(`This Ops manager has no associated shippers`);
            return;
        }
        setPage(1);
        setQuery(newQuery);
    };
    const handlePageChange = (page) => {
        setPage(page);
        const newQuery = Object.assign(Object.assign({}, query), { skip: (page - 1) * PER_PAGE });
        setQuery(newQuery);
    };
    function openModalButtonClick(type, modalData) {
        let modalType = null;
        if (type === TOTAL_COMMITMENT) {
            modalType = totalCommitmentModal;
        }
        else if (type === COMMITMENT_DISPATCHED) {
            modalType = commitmentDispatchedModal;
        }
        else if (type === CONTAINERS_DISPATCHED) {
            modalType = containersDispatchedModal;
        }
        else if (type === CONTAINERS_NOT_AVAILABLE) {
            modalType = containersNotAvailableModal;
        }
        else if (LFD_MODAL_TYPES.indexOf(type) > -1) {
            modalType = LastFreeDayModal;
        }
        else if (type === CARRIER_WITH_RATES) {
            modalType = carriersWithRateModal;
        }
        else if (type === CARRIER_WITH_NO_RATES) {
            modalType = carriersWithNoRateModal;
        }
        else if (type === CONTAINERS_AVAILABLE) {
            modalType = containersAvailableModal;
        }
        else if (type === CARRIER_WITH_OFFER) {
            modalType = carrierOfferModal;
        }
        setModalType(type);
        setModalItems(modalData);
        setModalIndex(modalData.index);
        setOfferPlannerModalBody(modalType);
        setShowOfferPlannerModal(true);
    }
    return (React.createElement(Container, { className: "py-10" },
        React.createElement("div", { className: "right-16" }, renderOfferPlannerHeader()),
        React.createElement("div", null,
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { className: "btn button-green" }, "LFD"),
                React.createElement(Button, { className: "btn" }, "ETA"))),
        React.createElement("hr", null),
        React.createElement("div", null, renderActiveFilters()),
        React.createElement("div", { className: "flex" },
            React.createElement("div", { className: "w-full md:w-1/6 px-3" }, renderZoneField(ORIGIN)),
            React.createElement("div", { className: "w-full md:w-1/6 px-3" }, renderZoneField(DESTINATION)),
            React.createElement("div", { className: "w-full md:w-1/6 px-3" }, renderFilterbyMarketMulti()),
            React.createElement("div", { className: "w-full md:w-1/6 px-3" }, renderServiceTypesMulti()),
            React.createElement("div", { className: "w-full md:w-1/6 px-3" }, renderFilterbyLfd()),
            React.createElement("div", { className: "w-full md:w-1/6 px-3" }, renderShippers()),
            React.createElement("div", { className: "w-full md:w-1/6 px-3" },
                " ",
                renderAdmins()),
            showOfferPlannerModal && (React.createElement(OfferPlannerModal, { show: showOfferPlannerModal, onClose: () => setShowOfferPlannerModal(false), body: offerPlannerModalBody, type: modalType, items: modalItems, setItems: setModalItems, widthClass: offerPlannerModalBody.widthClass || 'w-2/3', confirmationModal: confirmationModal, setConfirmationModal: setConfirmationModal, offerPlanners: offerPlanners, offerPlannersIndex: modalIndex, refreshData: () => getOfferPlannerList(query) }))),
        React.createElement("div", null,
            React.createElement("div", { className: "flex" },
                React.createElement(ActiveFilters, { query: Object.assign(Object.assign({}, query), { sortBy: query.sortColumn }), onRemove: onFilterChanged, onClear: () => setQuery({}) })),
            loading && (React.createElement("div", { className: "p-4" },
                React.createElement(LoadingCircle, { text: "LOADING LANES..." }))),
            !loading && hasOfferPlanners ? (React.createElement("div", null,
                React.createElement(Pagination, { key: 1, perPage: PER_PAGE, page: page, pages: paginationPages, total: paginationCount, onPageClick: (page) => {
                        handlePageChange(page);
                    }, showCount: true }),
                React.createElement(OfferPlannersList, { sortColumn: query.sortColumn, sortBy: query.sortBy, sortOrder: query.sortOrder, marketMulti: (marketMulti === null || marketMulti === void 0 ? void 0 : marketMulti.length) ? marketMulti : null, originZone: (originZone === null || originZone === void 0 ? void 0 : originZone.length) ? originZone : null, destinationZone: (destinationZone === null || destinationZone === void 0 ? void 0 : destinationZone.length) ? destinationZone : null, serviceType: (serviceType === null || serviceType === void 0 ? void 0 : serviceType.length)
                        ? _.map(serviceType, (type) => type.toLowerCase())
                        : null, lfdValue: lfdValue || null, onHeaderClick: onHeaderClick, offerPlanners: offerPlanners, perPage: PER_PAGE, page: page, pages: Math.round(offerPlanners.length / PER_PAGE), total: offerPlanners.length, columns: columns, showOfferPlannerModal: openModalButtonClick, hideOfferPlannerModal: () => setShowOfferPlannerModal(false), onEditActionClick: openModalButtonClick, setOfferPlanners: setOfferPlanners, offerPlannersIndex: modalIndex, setItems: setModalItems }))) : (React.createElement("div", null,
                " ",
                !loading && `NO LANES FOUND`,
                " ")))));
}
